declare namespace $ {

	type __ink_currency_app_1 = $mol_type_enforce<
		Parameters< $ink_currency_app['input'] >[0]
		,
		Parameters< ReturnType< $ink_currency_app['Calculator'] >['input'] >[0]
	>
	type __ink_currency_app_2 = $mol_type_enforce<
		Parameters< $ink_currency_app['digit'] >[0]
		,
		Parameters< ReturnType< $ink_currency_app['Calculator'] >['digit'] >[0]
	>
	type $mol_view__sub_ink_currency_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_ink_currency_app_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_ink_currency_app_5 = $mol_type_enforce<
		ReturnType< $ink_currency_app['preset_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_ink_currency_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_button_minor__click_ink_currency_app_7 = $mol_type_enforce<
		ReturnType< $ink_currency_app['preset_remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_ink_currency_app_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_ink_currency_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_ink_currency_app_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__sub_ink_currency_app_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_ink_currency_app_12 = $mol_type_enforce<
		ReturnType< $ink_currency_app['preset_save'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_link__uri_ink_currency_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_ink_currency_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_ink_currency_app_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link_support__uri_ink_currency_app_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_support['uri'] >
	>
	type $mol_link_support__Icon_ink_currency_app_17 = $mol_type_enforce<
		ReturnType< $ink_currency_app['Telegram_icon'] >
		,
		ReturnType< $mol_link_support['Icon'] >
	>
	type $mol_link_source__uri_ink_currency_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_view__sub_ink_currency_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_ink_currency_app_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_pick__trigger_content_ink_currency_app_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_ink_currency_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_locale_select__Trigger_icon_ink_currency_app_23 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_locale_select['Trigger_icon'] >
	>
	type $mol_locale_select__align_ink_currency_app_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_locale_select['align'] >
	>
	type $mol_locale_select__dictionary_ink_currency_app_25 = $mol_type_enforce<
		ReturnType< $ink_currency_app['lang_dictionary'] >
		,
		ReturnType< $mol_locale_select['dictionary'] >
	>
	type $mol_locale_select__Filter_ink_currency_app_26 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_locale_select['Filter'] >
	>
	type $mol_page__title_ink_currency_app_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_ink_currency_app_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__tools_ink_currency_app_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__foot_ink_currency_app_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_button_minor__click_ink_currency_app_31 = $mol_type_enforce<
		ReturnType< $ink_currency_app['refresh'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_32 = $mol_type_enforce<
		ReturnType< $ink_currency_app['refresh_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_ink_currency_app_33 = $mol_type_enforce<
		ReturnType< $ink_currency_app['online'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_ink_currency_app_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $ink_currency_string__value_ink_currency_app_35 = $mol_type_enforce<
		ReturnType< $ink_currency_app['input'] >
		,
		ReturnType< $ink_currency_string['value'] >
	>
	type $ink_currency_string__currency_ink_currency_app_36 = $mol_type_enforce<
		ReturnType< $ink_currency_app['currency'] >
		,
		ReturnType< $ink_currency_string['currency'] >
	>
	type $ink_currency_string__arg_ink_currency_app_37 = $mol_type_enforce<
		({ 
			'type': string,
		}) 
		,
		ReturnType< $ink_currency_string['arg'] >
	>
	type $ink_currency_string__value_ink_currency_app_38 = $mol_type_enforce<
		ReturnType< $ink_currency_app['output'] >
		,
		ReturnType< $ink_currency_string['value'] >
	>
	type $ink_currency_string__currency_ink_currency_app_39 = $mol_type_enforce<
		ReturnType< $ink_currency_app['currency'] >
		,
		ReturnType< $ink_currency_string['currency'] >
	>
	type $ink_currency_string__arg_ink_currency_app_40 = $mol_type_enforce<
		({ 
			'type': string,
		}) 
		,
		ReturnType< $ink_currency_string['arg'] >
	>
	type $mol_button_minor__click_ink_currency_app_41 = $mol_type_enforce<
		ReturnType< $ink_currency_app['clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_43 = $mol_type_enforce<
		ReturnType< $ink_currency_app['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_ink_currency_app_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_ink_currency_app_45 = $mol_type_enforce<
		ReturnType< $ink_currency_app['revert'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_ink_currency_app_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_ink_currency_app_47 = $mol_type_enforce<
		ReturnType< $ink_currency_app['divide'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_49 = $mol_type_enforce<
		ReturnType< $ink_currency_app['digit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_50 = $mol_type_enforce<
		ReturnType< $ink_currency_app['digit_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_51 = $mol_type_enforce<
		ReturnType< $ink_currency_app['multiply'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_53 = $mol_type_enforce<
		ReturnType< $ink_currency_app['subtract'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_55 = $mol_type_enforce<
		ReturnType< $ink_currency_app['add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_57 = $mol_type_enforce<
		ReturnType< $ink_currency_app['decimal'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_59 = $mol_type_enforce<
		ReturnType< $ink_currency_app['percent'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_ink_currency_app_61 = $mol_type_enforce<
		ReturnType< $ink_currency_app['equal'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_ink_currency_app_62 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_view__sub_ink_currency_app_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_ink_currency_app_64 = $mol_type_enforce<
		ReturnType< $ink_currency_app['title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_ink_currency_app_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_ink_currency_app_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $ink_currency_select__auto_ink_currency_app_67 = $mol_type_enforce<
		ReturnType< $ink_currency_app['list_auto'] >
		,
		ReturnType< $ink_currency_select['auto'] >
	>
	type $ink_currency_select__type_ink_currency_app_68 = $mol_type_enforce<
		ReturnType< $ink_currency_app['type'] >
		,
		ReturnType< $ink_currency_select['type'] >
	>
	export class $ink_currency_app extends $mol_book2 {
		Theme( ): $mol_theme_auto
		add( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['add'] >
		subtract( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['subtract'] >
		equal( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['equal'] >
		percent( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['percent'] >
		input( next?: ReturnType< ReturnType< $ink_currency_app['Calculator'] >['input'] > ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['input'] >
		divide( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['divide'] >
		digit( id: any): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['digit'] >
		delete( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['delete'] >
		decimal( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['decimal'] >
		clear( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['clear'] >
		multiply( ): ReturnType< ReturnType< $ink_currency_app['Calculator'] >['multiply'] >
		current_value( ): string
		Current_value( ): $mol_view
		preset_arg( id: any): Record<string, any>
		preset_input( id: any): string
		Preset_to( id: any): $mol_icon_arrow_right
		preset_output( id: any): string
		preset_value( id: any): string
		Preset_value( id: any): $mol_view
		Preset_name( id: any): $mol_link
		preset_remove( id: any): any
		Preset_remove_icon( id: any): $mol_icon_trash_can_outline
		Preset_remove( id: any): $mol_button_minor
		Preset( id: any): $mol_view
		presets_rows( ): readonly(any)[]
		Presets( ): $mol_list
		Preset_icon( ): $mol_icon_plus
		preset_save( ): any
		Preset_save( ): $mol_button_minor
		Info_icon( ): $mol_icon_information_outline
		Github_icon( ): $mol_icon_github
		Info_github( ): $mol_link
		Telegram_icon( ): $mol_icon_telegram
		Support( ): $mol_link_support
		Source( ): $mol_link_source
		Info_row( ): $mol_view
		Info_content( ): $mol_list
		Info( ): $mol_pick
		lang_dictionary( ): ({ 
			'ru': string,
			'en': string,
		}) 
		Lang( ): $mol_locale_select
		Lights( ): $mol_lights_toggle
		Menu( ): $mol_page
		title( ): string
		refresh( next?: any ): any
		refresh_title( ): string
		online( ): boolean
		Refresh_icon( ): $mol_icon_refresh
		Refresh( ): $mol_button_minor
		currency( id: any, next?: string ): string
		Input( ): $ink_currency_string
		output( ): string
		Output( ): $ink_currency_string
		Clear( ): $mol_button_minor
		Delete_icon( ): $mol_icon_backspace_outline
		Delete( ): $mol_button_minor
		revert( ): any
		Revert_icon( ): $mol_icon_swap_vertical
		Revert( ): $mol_button_minor
		Divide( ): $mol_button_minor
		digit_title( id: any): string
		Digit( id: any): $mol_button_minor
		Multiply( ): $mol_button_minor
		Subtract( ): $mol_button_minor
		Add( ): $mol_button_minor
		Decimal( ): $mol_button_minor
		Percnet( ): $mol_button_minor
		Equal( ): $mol_button_minor
		Keyboard( ): $mol_view
		Default( ): $mol_page
		list_auto( ): any
		type( ): any
		List( ): $ink_currency_select
		plugins( ): readonly(any)[]
		Calculator( ): $ink_calculator
		Placeholder( ): any
		hotkeys( ): ({ 
			'add': string,
			'subtract': string,
			'equal': string,
			'percent': string,
			'divide': string,
			'digit': string,
			'delete': string,
			'decimal': string,
			'clear': string,
			'multiply': string,
		}) 
		pages( ): readonly(any)[]
	}
	
	type $mol_view__sub_ink_currency_string_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_ink_currency_string_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_ink_currency_string_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_ink_currency_string_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $ink_currency_string extends $mol_link {
		currency( ): string
		currency_text( ): ReturnType< $ink_currency_string['currency'] >
		Flag( ): $mol_view
		value( ): string
		text( ): ReturnType< $ink_currency_string['value'] >
		Value( ): $mol_view
		symbol( ): ReturnType< $ink_currency_string['currency'] >
		Symbol( ): $mol_view
		Text( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map